export default __webpack_public_path__ + "static/media/Create_New_Email_Icon.ae5a3ba5.svg";